export default __webpack_public_path__ + "39da84ec8213e631c8a02605d101837b.svg";